import clx from 'classnames';
import { darken, lighten } from 'polished';
import styled from 'styled-components';
import {
  ResponsiveCard,
  type ResponsiveCardProps,
} from '../card/ResponsiveCard.tsx';

const SummaryPanelResponsiveCard = styled(ResponsiveCard)`
  &&& {
    box-shadow: ${props => props.theme.boxShadowTailwindMd};
    border: 1px solid ${props => props.theme.colorSplit};
    border-color: ${props =>
      darken(0.04, props.theme.Layout?.bodyBg ?? props.theme.colorBgLayout)};

    &.is-signer {
      border: 1px solid ${props => props.theme.moduleDelegateColor};
      background-color: ${props =>
        lighten(0.47, props.theme.moduleDelegateColor)};
    }

    /* Pari altezza solo quando le card sono affiancate (es. dati anagrafici) */
    &.full-height {
      height: 100%;
    }
  }
`;

export interface ISummaryDetailCardProps extends ResponsiveCardProps {
  variant?: 'default' | 'signer';
  /** Estende la card all'altezza del contenitore (card affiancate a pari altezza) */
  fullHeight?: boolean;
}

/**
 * Card stilizzata che racchiude le sezioni del riepilogo esteso.
 * Utilizzata per evidenziare visivamente le diverse sezioni del riepilogo esteso.
 *
 * Varianti:
 * - `default`: border grigio + sfondo neutro
 * - `signer`: border e sfondo colorati (moduleDelegateColor) per le sezioni di firma
 */
export function SummaryDetailCard(props: ISummaryDetailCardProps) {
  const {
    children,
    variant = 'default',
    fullHeight = false,
    className,
    ...cardProps
  } = props;

  return (
    <SummaryPanelResponsiveCard
      bordered
      className={clx(className, {
        'is-signer': variant === 'signer',
        'full-height': fullHeight,
      })}
      {...cardProps}
    >
      {children}
    </SummaryPanelResponsiveCard>
  );
}
